// @ts-nocheck

import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';
import { claimBoomReward, flushNotifications, skipCurrentTemporaryNotification } from '../../actions/boom';
import { useBoomModalContext } from '../../contexts/BoomModalContext';
import { selectBoomFirstTmpNotification } from '../../selectors/notifications.selector';

import BoomNotification from './BoomNotification';
import selectBoomNotificationProps from './BoomNotification.selector';

type BoomNotificationContainerProps = {
  className?: string;
};

const BoomNotificationContainer = (ownProps: BoomNotificationContainerProps) => {
  const { setDisableScrollView } = useBoomModalContext();
  const dispatch = useDispatch();
  const notification = useSelector(selectBoomFirstTmpNotification);
  const selectedProps = useSelector(selectBoomNotificationProps);

  useEffect(() => {
    if (notification) {
      setDisableScrollView(true);
      dispatch(flushNotifications());
    } else {
      setDisableScrollView(false);
    }
  }, [dispatch, notification, setDisableScrollView]);

  const actionsProps = useMemo(
    () => ({
      onClaimReward: () => {
        dispatch(skipCurrentTemporaryNotification());
        dispatch(claimBoomReward({ uuid: notification?.uuid }));
      },
    }),
    [dispatch, notification?.uuid],
  );

  const enhancedProps = useMergeProps({ actionsProps, ownProps, selectedProps });

  return notification ? <BoomNotification {...enhancedProps} /> : null;
};

export default BoomNotificationContainer;
